import { PromotionType } from '../types/offers';

const sortFeaturedOffers = (offers: PromotionType[]) => {
  if (!offers.length) return [];
  return [...offers].sort((a, b) => {
    // Sort by region. National are last
    if ((a.region === 'USA') !== (b.region === 'USA')) {
      return b.region === 'USA' ? -1 : 1;
    }

    // Sort by priority program
    if (a.programPriority !== b.programPriority) {
      return b.programPriority - a.programPriority;
    }

    // If offers have the same type, applying specific sorting rules based on offer type
    if (a.offerType === b.offerType) {
      switch (a.offerType) {
        case 'lease':
          return a.monthlyPayment - b.monthlyPayment;
        case 'finance':
          return a.aprRate - b.aprRate;
        case 'credit':
          return b.creditBonus - a.creditBonus;
        default:
          return 0;
      }
    }
    return 0;
  });
};

export default sortFeaturedOffers;
